import React from 'react';
import { Container, Content, Header } from 'rsuite';
import Footer from '@/views/_layouts/Footer';
import AppLogo from '@/components/shared/AppLogo';

/**
 * 错误提示页面布局，用于 _404.tsx 和 _error.tsx
 * - 左上角 logo 和应用名
 * - 右下角 copyright
 * - 中间占位图片和提示内容
 */
export default function ErrorLayout({ children }) {
  const appName = process.env.REACT_APP_NAME;

  return (
    <Container
      className="error-layout"
      style={{
        height: 'calc(100vh - var(--headerHeight) - var(--navBarHeight)',
      }}
    >
      <Header className="error-layout-header">
        <AppLogo style={{ marginRight: '1em' }} />
        {appName}
      </Header>
      <Content className="main-content" style={{ minHeight: 'auto', flexGrow: 1 }}>
        <div className="error-wrapper">{children}</div>
      </Content>
      <Footer align="right" />
    </Container>
  );
}
